/* eslint-disable perfectionist/sort-enums -- Sorted by increasing BMI */
export enum BMICategories {
    underweight = 'Ondergewicht',
    normalWeight = 'Normaal gewicht',
    slightlyOverweight = 'Licht overgewicht',
    moderatelyOverweight = 'Matig overgewicht',
    severelyOverweight = 'Ernstig overgewicht (obesitas)',
    verySeverelyOverweight = 'Zeer ernstig overgewicht (morbide obesitas)',
}
